import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import { useStyles } from "../../../../Component/CSS/SearchFilterStyle.css";

class SearchFilterAuthor extends Component {
  render() {
    const { classes, data, handleChange } = this.props;
    return (
      <div>
        <div style={{ fontSize: 16 }}>Search By</div>
        <div className={classes.fieldStyle}>
          <TextField
            name="firstName"
            type="text"
            label="First Name"
            margin="normal"
            variant="outlined"
            fullWidth
            style={{ marginRight: 10 }}
            placeholder="Search by first name"
            InputProps={{
              classes: {
                root: classes.inputroot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.firstName}
            onChange={handleChange}
          />
          <TextField
            name="lastName"
            type="text"
            label="Last Name"
            margin="normal"
            variant="outlined"
            fullWidth
            // className={classes.nameinputStyle}
            placeholder="Search by last name"
            InputProps={{
              classes: {
                root: classes.inputroot,
                notchedOutline: classes.notchedOutline,
                focused: classes.focused,
              },
            }}
            InputLabelProps={{
              classes: {
                root: classes.labelRoot,
                focused: classes.labelFocused,
              },
              shrink: true,
            }}
            value={data.lastName}
            onChange={handleChange}
          />
        </div>
      </div>
    );
  }
}

export default withStyles(useStyles)(SearchFilterAuthor);
